import React, {useEffect, useState} from 'react'

const PurchaseRowTotal = ({record, rowIndex}) => {
    const [totalPrice, setTotalPrice] = useState(0)

    useEffect(() => {
        let total = record.quantity * (record.unitPrice || 0)
        if (record.discount) total -= total * record.discount / 100
        setTotalPrice(total)
    }, [record.quantity, record.unitPrice, record.discount, record.stock])

    return (
        <React.Fragment>
            <span>{new Intl.NumberFormat().format(totalPrice)}</span>
        </React.Fragment>
    )
}
export default PurchaseRowTotal